"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _context = require("../../services/auth/context");
var _ = _interopRequireDefault(require("."));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Renderer = props => {
  var _props$isSimplifiedLo;
  const {
    modal,
    onCloseModal,
    onSetAuth
  } = (0, _context.useAuth)();
  if (modal === null) {
    return null;
  }
  const onGetSimpleToken = props.onGetSimpleToken ? props.onGetSimpleToken : onSetAuth;
  // These props can be set globally and overridden by ".onOpenModal()" call in specific cases
  const initialScreen = modal.initialScreen != null ? modal.initialScreen : props.initialScreen;
  const type = modal.type != null ? modal.type : props.type;
  const origin = modal.origin != null ? modal.origin : props.origin;
  const onSignInFulfill = modal.onSignInFulfill != null ? modal.onSignInFulfill : props.onSignInFulfill;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.default, {
    ...props,
    initialScreen: initialScreen,
    initialEmail: modal.initialEmail,
    type: type || "mmb",
    origin: origin,
    onClose: onCloseModal,
    onSignInFulfill: onSignInFulfill,
    onContinueAsGuest: modal.onContinueAsGuest,
    onGetSimpleToken: onGetSimpleToken,
    isSimplifiedLoginFlow: (_props$isSimplifiedLo = props.isSimplifiedLoginFlow) !== null && _props$isSimplifiedLo !== void 0 ? _props$isSimplifiedLo : false,
    hideCloseButton: modal.hideCloseButton,
    customTitle: modal.customTitle,
    customDescription: modal.customDescription
  });
};
var _default = Renderer;
exports.default = _default;